import { combineReducers } from "redux";
import { mainSystemUserReducer } from "./mainSystemReducer";
import { kepsSystemReducer } from './kepsSystemReducer';
import { sanalSinavSystemReducer } from './sanalSinavSystemReducer';
const reducers = combineReducers({
    remoteSystem: mainSystemUserReducer,
    kepsSystem: kepsSystemReducer,
    sanalSinavSystem: sanalSinavSystemReducer
});
export default reducers;